import TpsUnitMapping from './TpsUnitMapping'
import MisoUnitMapping from './MisoUnitMapping'
import PPR from './PPR'
import React, { useMemo } from 'react'
import { Route } from 'react-router-dom'
import * as ScreenPermissions from 'core/EventActions'
import { hasAccesPermits } from 'core'
import TpsFileLog from './TpsFileLog'
import TpsImportMaData from './TpsImportMaData'
import MisoImportMaData from './MisoImportMaData'

export {
  TpsUnitMapping,
  MisoUnitMapping,
  PPR,
  TpsFileLog,
  TpsImportMaData,
  MisoImportMaData,
}

export const ClecoRouteExport = ({ actionPermits }) => {
  const tpsUnitMappingAccess = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [
          ScreenPermissions.TPS_UNIT_MAPPING_READ,
          ScreenPermissions.TPS_UNIT_MAPPING_WRITE,
        ],
        matchAny: true,
      }),
    [actionPermits]
  )

  const misoUnitMappingAccess = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [
          ScreenPermissions.MISO_UNIT_MAPPING_READ,
          ScreenPermissions.MISO_UNIT_MAPPING_WRITE,
        ],
        matchAny: true,
      }),
    [actionPermits]
  )

  const tpsMaDataImportAccess = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.TPS_MA_DATA_IMPORT],
        matchAny: true,
      }),
    [actionPermits]
  )
  const misoMaDataImportAccess = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.MISO_MA_DATA_IMPORT],
        matchAny: true,
      }),
    [actionPermits]
  )
  const pprAccess = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.PPR_EXPORT],
        matchAny: true,
      }),
    [actionPermits]
  )

  return (
    <>
      {' '}
      {tpsUnitMappingAccess && (
        <Route
          key="tps-unit-mapping"
          exact
          path="/tps-unit-mapping"
          component={TpsUnitMapping}
        />
      )}
      {misoUnitMappingAccess && (
        <Route
          key="miso-unit-mapping"
          exact
          path="/miso-unit-mapping"
          component={MisoUnitMapping}
        />
      )}
      {pprAccess && <Route key="ppr" exact path="/ppr" component={PPR} />}
      <Route
        key="tps-file-log"
        exact
        path="/tps-file-log"
        component={TpsFileLog}
      />
      {tpsMaDataImportAccess && (
        <Route
          key="tps-import-ma-data"
          exact
          path="/tps-import-ma-data"
          component={TpsImportMaData}
        />
      )}
      {misoMaDataImportAccess && (
        <Route
          key="miso-import-ma-data"
          exact
          path="/miso-import-ma-data"
          component={MisoImportMaData}
        />
      )}
    </>
  )
}
